import { Box } from '@material-ui/core';
import React from 'react';
import Button from '@material-ui/core/Button';

const ButtonWithBorder = ({ buttonList, buttonClick, isSelected }) => {
    return (
        <React.Fragment>
            {buttonList &&
                Array.isArray(buttonList) &&
                buttonList.map((bt) => {
                    return (
                        <Box
                            component={Button}
                            key={bt.title}
                            id={`button-${bt.title}`} 
                            variant="light"
                            className={
                                isSelected === bt.title
                                    ? 'buttonStyleWithBorder'
                                    : 'buttonStyle'
                            }
                            onClick={() => buttonClick(bt.title)}
                        >
                            {bt.title}
                        </Box>
                    );
                })}
        </React.Fragment>
    );
};

export default ButtonWithBorder;
